<template>
	<edit-user-form ref="form" form-type="contactPersonalInfo">
		<template #default="{ form, rules, inputColor, canEdit, update }">
			<v-row class="pa-2" dense>
				<!-- FIRST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.firstName"
						:rules="[rules.required]"
						:color="inputColor"
						label="First Name"
						:readonly="!canEdit"
						@input="update(['firstName', $event])"
					/>
				</v-col>
				<!-- LAST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.lastName"
						:rules="[rules.required]"
						:color="inputColor"
						label="Last Name"
						:readonly="!canEdit"
						@input="update(['lastName', $event])"
					/>
				</v-col>
				<!-- RELATIONSHIP -->
				<v-col cols="12" sm="6">
					<v-select
						v-model="form.data.relationship"
						:rules="[rules.required]"
						:color="inputColor"
						:items="relationshipItems"
						:append-icon="canEdit ? 'fa-caret-down' : ''"
						label="Relationship"
						:readonly="!canEdit"
						@input="update(['relationship', $event])"
					/>
				</v-col>
				<!-- EMAIL -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.email"
						:rules="[rules.required, rules.email]"
						:color="inputColor"
						label="Email"
						type="email"
						:readonly="!canEdit"
						@input="update(['email', $event])"
					/>
				</v-col>
				<!-- PHONE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.primaryPhone"
						:rules="[rules.requiredIf(isPhoneRequired), rules.phone]"
						:color="inputColor"
						label="Phone"
						:readonly="!canEdit"
						@input="update(['primaryPhone', $event])"
					/>
				</v-col>
			</v-row>
		</template>
	</edit-user-form>
</template>

<script>
import EditUserForm from "./EditUserForm";

const relationshipItems = [
	"Spouse",
	"Sibling",
	"Son",
	"Daughter",
	"Grandson",
	"Granddaughter",
	"Friend",
	"Other",
	{ text: "In-Laws", value: "In_Laws" }
];

export default {
	components: { EditUserForm },

	data() {
		return {
			relationshipItems,
			isPhoneRequired: false,
		}
	},

	mounted() {
		// checks if there is a phone number already (currently graphql
		// api does not have a way to "remove" properties from contact)
		this.isPhoneRequired = !!this.$refs.form.form.data.primaryPhone;
	},
};
</script>
